import {isNil} from 'ramda';
import {isNilOrEmpty, isFalse} from 'ramda-adjunct';

import {NormalizedFastTrackItems} from '@dms/api/warehouse';

export const isReceiveNoteFastTracksPending = (
  fastTrackItems: NormalizedFastTrackItems | undefined
): boolean => {
  if (isNil(fastTrackItems) || isNilOrEmpty(fastTrackItems.itemIds)) {
    return false;
  }

  return fastTrackItems.itemIds.some((id) => isFalse(fastTrackItems.items[id]?.isAccepted));
};
